<div [formGroup]="formControl">
  <div [ngSwitch]="field.field">
    <!-- sur l'instruction -->
    <div *ngSwitchCase="'by_instructions__state'"
         fxFlex="20"
         class="field__box" fxLayout="column">
      <mat-select
        formControlName="value"
        multiple="true"
        [placeholder]="field.placeHolder"
        [attr.data-cy]="'select-filter-type-'+field.placeHolder">
        <mat-select-trigger>
          <mat-icon [attr.data-cy]="'icon-filter-type-'+field.placeHolder">{{valueSelect?.icon}}</mat-icon>&nbsp;{{valueSelect?.label}}
        </mat-select-trigger>
        <mat-option *ngFor="let option of statesResponses" [value]="option" [attr.data-cy]="'option-filter-type-'+option.id">
          <span [matTooltip]="option?.explain"><mat-icon [ngStyle]="{'color': option?.color || 'initial'}">{{option?.icon}}</mat-icon>{{option.label}}</span>
        </mat-option>
      </mat-select>
    </div>
    <!-- sur une date modification ou création -->
    <!-- template pour les dates -->
    <ng-template #filterDateTemplate let-placeholder="placeholder">
      <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
        <input
          formControlName="value"
          [placeholder]="placeholder"
          [matDatepicker]="picker"
          matInput>
        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </ng-template>
    <!-- date création ou modification -->
    <div *ngSwitchCase="'dt_created'"
         fxFlex="20"
         class="field__box" fxLayout="column">
      <ng-container *ngTemplateOutlet="filterDateTemplate; context: {'placeholder': field.placeHolder}"></ng-container>
    </div>
    <div *ngSwitchCase="'dt_updated'"
         fxFlex="20"
         class="field__box" fxLayout="column">
      <ng-container *ngTemplateOutlet="filterDateTemplate; context: {'placeholder': field.placeHolder}"></ng-container>
    </div>
  </div>
</div>

